import React, { useEffect, useState } from 'react';
import { useNotifications } from '../../context/NotificationContext';
import './style.css';

export default function RealtimeIndicator() {
  const { notifications } = useNotifications();
  const [lastNotificationTime, setLastNotificationTime] = useState(null);
  const [showNewNotification, setShowNewNotification] = useState(false);

  // Show indicator when new notification arrives
  useEffect(() => {
    if (notifications.length > 0) {
      const latestNotification = notifications[0];
      const notificationTime = new Date(latestNotification.createdAt).getTime();
      
      if (lastNotificationTime && notificationTime > lastNotificationTime) {
        setShowNewNotification(true);
        // Hide the indicator after 3 seconds
        setTimeout(() => {
          setShowNewNotification(false);
        }, 3000);
      }
      
      setLastNotificationTime(notificationTime);
    }
  }, [notifications, lastNotificationTime]);

  return (
    <div className="realtime-indicator">
      {/* Connection status - Hidden but keeping for debugging if needed */}
      {/* 
      <div className={`connection-status ${isConnected ? 'connected' : 'disconnected'}`}>
        <div className="status-dot"></div>
        <span className="status-text">
          {isConnected ? 'Real-time ON' : 'Connecting...'}
        </span>
      </div>
      */}
      
      {/* New notification alert */}
      {showNewNotification && (
        <div className="new-notification-alert">
          <div className="alert-content">
            <span className="bell-icon">🔔</span>
            <span>New notification received!</span>
          </div>
        </div>
      )}
    </div>
  );
} 